function useIsEmailOrPhone(value = "") {
  if (value.match(/[a-zA-Z]/)) {
    return "email";
  }
  return "phone";
}
export {
  useIsEmailOrPhone
};
//# sourceMappingURL=use-is-email-or-phone.js.map
